<template>
    <div class="support">
        <default :items="items" :title="'Support'" :withAccordion="true">
            <template v-if="loaded" slot="content-after-accordion">
                <div class="acc-wrap" ref="contact-form">
                    <accordion-item :title="'Other' | translate | normalize" :use-slot-content="true" :custom-container="true" :pre-opened="open_form">
                        <template slot="acc-content">
                            <div class="contact-form">
                                <div class="form-wrapper">
                                    <form autocomplete="off" @submit.prevent="submit">
                                        <div class="form-group contact-info-con">
                                            <p>{{ 'Didn\'t find what you were looking for?' | translate }}</p>
                                            <p>{{ 'Please send us an email and we will get back to you.' | translate }}</p>
                                            <p  class="info-text email">
                                                <a :href="`mailto:support@${host_name}`">
                                                    <i class="fa fa-envelope"></i>{{ `support@${host_name}` }}
                                                </a>
                                            </p>
                                            <p class="info-text email toggler-con">
                                                <span class="toggler" @click="open_info = !open_info">
                                                    <i :class="`fa fa-${!open_info ? 'plus': 'minus'}`"></i>{{ 'Or contact us using the form' | translate }}
                                                </span>
                                            </p>
                                        </div>
                                        <tempalte v-if="open_info">
                                            <div v-if="!showDesktop" class="form-group has-border-btm">
                                                <p>{{ 'All fields are required' | translate }}</p>
                                            </div>
                                            <div class="form-group" v-if="!canSubmit">
                                                <div class="error-msg-con">
                                                    <i class="fa fa-exclamation-triangle"></i> {{ 'The fields marked in red are required. Please fill them to continue.' | translate }}
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label>{{ 'Username' | translate }}</label>
                                                <div class="input-wrapper">
                                                    <input :class="`form-control darker-ph ${contact_formdata.name.error_msg ? 'invalid' : ''}`" type="text" :placeholder="'Will help us to identify you' | translate" v-model="contact_formdata.name.val" @input="validateInput(null, 'name')" @paste="validateInput($event, 'name')" :disabled="disable_name">
                                                    <div v-if="contact_formdata.name.error_msg" class="error-msg-con">
                                                        <i class="fa fa-exclamation-triangle"></i> {{ contact_formdata.name.error_msg | translate }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label>{{ 'Subject' | translate }}</label>
                                                <div class="input-wrapper">
                                                    <input :class="`form-control darker-ph ${contact_formdata.subject.error_msg ? 'invalid' : ''}`"  type="text" :placeholder="'Tell us how can we help you' | translate" v-model="contact_formdata.subject.val" @input="validateInput(null, 'subject')" @paste="validateInput($event, 'subject')">
                                                    <div v-if="contact_formdata.subject.error_msg" class="error-msg-con">
                                                        <i class="fa fa-exclamation-triangle"></i> {{ contact_formdata.subject.error_msg | translate }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label>{{ 'Email' | translate }}</label>
                                                <div class="input-wrapper">
                                                    <input :class="`form-control darker-ph ${contact_formdata.email.error_msg ? 'invalid' : ''}`"  type="text" :placeholder="'Connected to your account' | translate" v-model="contact_formdata.email.val" @input="validateInput(null, 'email')" @paste="validateInput($event, 'email')" :disabled="disable_email">
                                                    <div v-if="contact_formdata.email.error_msg" class="error-msg-con">
                                                        <i class="fa fa-exclamation-triangle"></i> {{ contact_formdata.email.error_msg | translate }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-show="!disable_email" class="form-group">
                                                <label>{{ 'Repeat Email' | translate }}</label>
                                                <div class="input-wrapper">
                                                    <input :class="`form-control darker-ph ${contact_formdata.email_repeat.error_msg ? 'invalid' : ''}`"  type="text" v-model="contact_formdata.email_repeat.val" @input="validateInput(null, 'email_repeat')"  @paste="validateInput($event, 'email_repeat')" :disabled="disable_email">
                                                    <div v-if="contact_formdata.email_repeat.error_msg" 
                                                    class="error-msg-con">
                                                        <i class="fa fa-exclamation-triangle"></i> {{ contact_formdata.email_repeat.error_msg | translate  }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label>{{ 'Message' | translate }}</label>
                                                <div class="input-wrapper">
                                                    <textarea :class="`form-control darker-ph desc ${contact_formdata.message.error_msg ? 'invalid' : ''}`"  type="text" v-model="contact_formdata.message.val" @input="validateInput(null, 'message')" @paste="validateInput($event, 'message')"></textarea>
                                                    <div v-if="contact_formdata.email_repeat.error_msg" 
                                                    class="error-msg-con with-textarea">
                                                        <i class="fa fa-exclamation-triangle"></i> {{ contact_formdata.email_repeat.error_msg | translate  }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="captcha-wrap">
                                                    <recaptcha ref="recaptcha" :class="`recaptcha ${contact_formdata['g-recaptcha-response'].error_msg ? 'invalid' : ''}`"  @verify="verifyRecaptcha"></recaptcha>
                                                </div>
                                                <div v-if="contact_formdata['g-recaptcha-response'].error_msg" 
                                                class="error-msg-con">
                                                    <i class="fa fa-exclamation-triangle"></i> {{ contact_formdata['g-recaptcha-response'].error_msg | translate }}
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="btn-wrap">
                                                    <button class="btn btn-primary btn-send">{{ 'Send message' | translate | normalize }}</button>
                                                </div>
                                                <p v-if="showDesktop" class="info-text">{{ 'All fields are required' | translate }}</p>
                                            </div>
                                        </tempalte>
                                    </form>
                                </div>
                            </div>
                        </template>
                    </accordion-item>
                </div>
                <div class="success-msg-con sent" v-if="sent_success">
                    {{ 'Your request was succesfully sent!' | translate }}
                </div>
                <div class="addres-image-con">
                    <img class="img-responsive" :src="image_address" :alt="`Business address ${site_name}`" v-cloak>
                </div>
            </template>
        </default>
    </div>
</template>

<script>
    import Default from '@views/public/layouts/Default'
    import AccordionItem from '@views/common/AccordionItem'
    import Recaptcha from '@views/common/Recaptcha'
    import Support from '@views/public/pages/Support/support'

    export default {
        mixins: [Support],
        components: {
            Default,
            AccordionItem,
            Recaptcha,
        }
    }
</script>

<style lang="scss" src="./support.scss"></style>
